module.exports = __webpack_public_path__ + "img/airtke_kill.5f01482d.jpg";